import { gql } from '@apollo/client'

export const LEAVE_FANTASY_LEAGUE = gql`
  mutation LeaveFantasyLeague($input: LeaveFantasyLeagueInput!) {
    leaveFantasyLeague(input: $input) {
      success
      errors
    }
  }
`
